import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getPreAccount(uuid) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${uuid}`;
        return this.api.get(uri);
    }
    getBusinessPartners(uuid) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${uuid}/business-partner`;
        return this.api.get(uri);
    }
    createPreAccount(preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account`;
        return this.api.post(uri, preAccount);
    }
    updatePreAccount(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateLastStep(id, step) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/last-step/${id}/step/?step=${step}`;
        return this.api.put(uri, null);
    }
    updatePersonalData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/personal-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateAddressData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/address-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateComercialAgent(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/comercial-agent-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updatedContract(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/contract/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateCompanyAddress(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/company-address/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateCompanyData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/company-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateProfessionalType(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/professional-type/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateBusinessPartner(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/business-partner/${id}`;
        return this.api.put(uri, preAccount);
    }
    createCompanyAddress(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/new`;
        return this.api.post(uri);
    }
    getCep(zipcode) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cep/${zipcode}`;
        return this.api.get(uri);
    }
    createTypeAccount(id, accountPaymentType, nextStep) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/type-account/${id}/next-step/${nextStep}`;
        return this.api.put(uri, accountPaymentType);
    }
    accountIsMoreFivek(id) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/account-more-five-thousand/${id}`;
        return this.api.post(uri);
    }
    // uploadFile(id: string, upload: UploadDto): Observable<PreAccount> {
    //     const uri = `${SPE_N_OPEN_ACCOUNT}/v1/upload/${id}`;
    //     return this.api.put(uri, upload);
    // }
    findTypeDocumentUploaded(id) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/uploaded-type-account/${id}`;
        return this.api.get(uri);
    }
    findByAccountType(idWhiteLAbel) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/account-type/white-label/${idWhiteLAbel}`;
        return this.api.get(uri);
    }
    findByWhiteLabelAndCpf(uuidWhiteLabel, cpf) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cpf/${cpf}/wlp/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    addUserInterest(userId, interests) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/interest/${userId}`;
        return this.api.put(uri, interests);
    }
    answerQuiz(body) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/data-mind/answer-quiz`;
        return this.api.post(uri, body);
    }
};
SpeNOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountProxy = __decorate([
    Injectable()
], SpeNOpenAccountProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_OPEN_ACCOUNT_UPLOAD = '/spe-n-open-account-upload';
let SpeNOpenAccountUploadProxy = class SpeNOpenAccountUploadProxy {
    constructor(api) {
        this.api = api;
    }
    uploadFile(id, upload) {
        const uri = `${SPE_N_OPEN_ACCOUNT_UPLOAD}/v1/upload/${id}`;
        return this.api.put(uri, upload);
    }
};
SpeNOpenAccountUploadProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountUploadProxy = __decorate([
    Injectable()
], SpeNOpenAccountUploadProxy);

const SPE_VIEW_PRE_ACCOUNT = '/spe-view-pre-account';
let SpeViewPreAccountProxy = class SpeViewPreAccountProxy {
    constructor(api) {
        this.api = api;
    }
    findPreAccount(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/${id}`;
        return this.api.get(uri);
    }
    findContract(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/contract/${id}`;
        return this.api.get(uri);
    }
    findComercialAgent(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/comercial-agent/${id}`;
        return this.api.get(uri);
    }
    findAccountType(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/account-type/${id}`;
        return this.api.get(uri);
    }
    findUploads(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/uploads/${id}`;
        return this.api.get(uri);
    }
    findPersonalData(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/personal-data/${id}`;
        return this.api.get(uri);
    }
    findPersonalAddress(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/address/${id}`;
        return this.api.get(uri);
    }
    findProfessionalType(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/professional-type/${id}`;
        return this.api.get(uri);
    }
    findPartners(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/partners/${id}`;
        return this.api.get(uri);
    }
    findCompanyData(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/company/${id}`;
        return this.api.get(uri);
    }
    findCompanyAddress(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/company-address/${id}`;
        return this.api.get(uri);
    }
    findAccountTypeByWhiteLabel(idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/account-type/white-label/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findStatusById(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/status/${id}`;
        return this.api.get(uri);
    }
    findEmailByIdAndEmailAndWhiteLabel(id, email, idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/verify-email/of-id/${id}/of-email/${email}/of-whitelabel/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findEmailByCpfAndEmailAndWhiteLabel(cpf, email, idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/verify-email/of-cpf/${cpf}/of-email/${email}/of-whitelabel/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findEmailByEmailAndWhiteLabel(email, idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/verify-email/of-email/${email}/of-whitelabel/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findInterests(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/domain/interest/wl/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findAccountMigration(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/migration/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
};
SpeViewPreAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewPreAccountProxy = __decorate([
    Injectable()
], SpeViewPreAccountProxy);

const SPE_VIEW_N_OPEN_ACCOUNT = '/spe-view-n-open-account';
let SpeViewOpenAccountProxy = class SpeViewOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCampaing(idDataFlow) {
        const uri = `${SPE_VIEW_N_OPEN_ACCOUNT}/v1/data-mind/campaing/${idDataFlow}`;
        return this.api.get(uri);
    }
    verifyAccountQuiz(body) {
        const uri = `${SPE_VIEW_N_OPEN_ACCOUNT}/v1/data-mind/flow`;
        return this.api.post(uri, body);
    }
    verifyCreateAccount(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_OPEN_ACCOUNT}/v1/availability/account-opening/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
};
SpeViewOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewOpenAccountProxy = __decorate([
    Injectable()
], SpeViewOpenAccountProxy);

const SPE_J_OPEN_ACCOUNT_UPLOAD = '/spe-j-open-account-upload';
let SpeJOpenAccountUploadProxy = class SpeJOpenAccountUploadProxy {
    constructor(api) {
        this.api = api;
    }
    uploadFile(id, upload) {
        let ownership = !!upload.ownership ? upload.ownership : '';
        const uri = `${SPE_J_OPEN_ACCOUNT_UPLOAD}/v1/image/upload/${id}?typeDocument=${upload.uploadType}&position=${upload.positionPhoto}&ownership=${ownership}`;
        let nameFile = !!upload.fileName ? upload.fileName : 'imagem.jpeg';
        // preparando objeto para converter para blob
        let image64 = upload.fileBase64;
        let block = image64.photo.split(";");
        let contentType = block[0].split(":")[1];
        let realData = block[1].split(",")[1];
        // convertendo para blob
        const blob = this.b64toBlob(realData, contentType);
        const formData = new FormData();
        const file = new File([blob], nameFile);
        formData.append('file', file);
        return this.api.post(uri, formData);
    }
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
};
SpeJOpenAccountUploadProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJOpenAccountUploadProxy = __decorate([
    Injectable()
], SpeJOpenAccountUploadProxy);

let UiPxSignupModule = class UiPxSignupModule {
};
UiPxSignupModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNOpenAccountProxy,
            SpeNOpenAccountUploadProxy,
            SpeJOpenAccountUploadProxy,
            SpeViewPreAccountProxy,
            SpeViewOpenAccountProxy,
            ConfigService
        ]
    })
], UiPxSignupModule);

var YesOrNot;
(function (YesOrNot) {
    YesOrNot["NOT"] = "NOT";
    YesOrNot["YES"] = "YES";
})(YesOrNot || (YesOrNot = {}));

var Status;
(function (Status) {
    Status["IN_ONBORDING"] = "IN_ONBORDING";
    Status["IN_ANALYSIS_COMPLIANCE"] = "IN_ANALYSIS_COMPLIANCE";
    Status["APPROVED_COMPLIANCE"] = "APPROVED_COMPLIANCE";
    Status["IN_ANALYSIS_BACKOFFICE"] = "IN_ANALYSIS_BACKOFFICE";
    Status["APPROVED_BACKOFFICE"] = "APPROVED_BACKOFFICE";
    Status["IN_ANALYSIS_TOPAZIO"] = "IN_ANALYSIS_TOPAZIO";
    Status["APPROVED_TOPAZIO"] = "APPROVED_TOPAZIO";
    Status["FINISHED"] = "FINISHED";
    Status["REPROVED"] = "REPROVED";
    Status["VALIDATION_REPROVED"] = "VALIDATION_REPROVED";
    Status["VALIDATION_ANALYSIS"] = "VALIDATION_ANALYSIS";
    Status["VALIDATION_PENDENT"] = "VALIDATION_PENDENT";
    Status["DOCUMENT_PHYSICAL_PERSON_REPROVED"] = "DOCUMENT_PHYSICAL_PERSON_REPROVED";
    Status["DOCUMENT_LEGAL_PERSON_REPROVED"] = "DOCUMENT_LEGAL_PERSON_REPROVED";
    Status["REGISTRATION_DATA_PHYSICAL_PERSON_INVALID"] = "REGISTRATION_DATA_PHYSICAL_PERSON_INVALID";
    Status["REGISTRATION_DATA_LEGAL_PERSON_INVALID"] = "REGISTRATION_DATA_LEGAL_PERSON_INVALID";
    Status["PENDENT"] = "PENDENT"; // Pendente ( Analise interno / Compliance )
})(Status || (Status = {}));

var LevelRiskEnum;
(function (LevelRiskEnum) {
    LevelRiskEnum["HIGH"] = "HIGH";
    LevelRiskEnum["MEDIUM"] = "MEDIUM";
    LevelRiskEnum["LOW"] = "LOW";
    LevelRiskEnum["NO_CLASSIFICATION"] = "NO_CLASSIFICATION";
})(LevelRiskEnum || (LevelRiskEnum = {}));

var TypeEnum;
(function (TypeEnum) {
    TypeEnum["MAIN"] = "MAIN";
    TypeEnum["RESIDENTIAL"] = "RESIDENTIAL";
    TypeEnum["COMMERCIAL"] = "COMMERCIAL";
    TypeEnum["MESSAGES"] = "MESSAGES";
})(TypeEnum || (TypeEnum = {}));

var MaritalEnum;
(function (MaritalEnum) {
    MaritalEnum["MARRIED"] = "MARRIED";
    MaritalEnum["DIVORCED"] = "DIVORCED";
    MaritalEnum["SINGLE"] = "SINGLE";
    MaritalEnum["WIDOWED"] = "WIDOWED";
})(MaritalEnum || (MaritalEnum = {}));

var Deleted;
(function (Deleted) {
    Deleted["FALSE"] = "FALSE";
    Deleted["TRUE"] = "TRUE";
})(Deleted || (Deleted = {}));

var TypeAccountEnum;
(function (TypeAccountEnum) {
    TypeAccountEnum["PHYSICAL_PERSON"] = "PHYSICAL_PERSON";
    TypeAccountEnum["LEGAL_PERSON"] = "LEGAL_PERSON";
    TypeAccountEnum["MEI"] = "MEI";
    TypeAccountEnum["LIBERAL_PROFESSIONAL"] = "LIBERAL_PROFESSIONAL";
})(TypeAccountEnum || (TypeAccountEnum = {}));

var PositionPhotoEnum;
(function (PositionPhotoEnum) {
    PositionPhotoEnum["FRONT"] = "FRONT";
    PositionPhotoEnum["VERSE"] = "VERSE";
})(PositionPhotoEnum || (PositionPhotoEnum = {}));

var UploadTypeEnum;
(function (UploadTypeEnum) {
    UploadTypeEnum["CPF"] = "CPF";
    UploadTypeEnum["CNPJ"] = "CNPJ";
    UploadTypeEnum["RESIDENCIAL_CERTIFICATE"] = "RESIDENCIAL_CERTIFICATE";
    UploadTypeEnum["RG"] = "RG";
    UploadTypeEnum["CNH"] = "CNH";
    UploadTypeEnum["SOCIAL_CONTRACT"] = "SOCIAL_CONTRACT";
    UploadTypeEnum["MEI_OPENING_TERMS"] = "MEI_OPENING_TERMS";
    UploadTypeEnum["MINUTES_MEETING"] = "MINUTES_MEETING";
    UploadTypeEnum["PROFESSIONAL_CERTIFICATE"] = "PROFESSIONAL_CERTIFICATE";
    UploadTypeEnum["SELF_PHOTO"] = "SELF_PHOTO";
    UploadTypeEnum["ATTORNEY_LETTER"] = "ATTORNEY_LETTER";
    UploadTypeEnum["RESIDENCIAL_CERTIFICATE_LEGAL_PERSON"] = "RESIDENCIAL_CERTIFICATE_LEGAL_PERSON";
})(UploadTypeEnum || (UploadTypeEnum = {}));

var StatusDefaultEnum;
(function (StatusDefaultEnum) {
    StatusDefaultEnum["INACTIVE"] = "INACTIVE";
    StatusDefaultEnum["ACTIVE"] = "ACTIVE";
})(StatusDefaultEnum || (StatusDefaultEnum = {}));

var TypeFlowEnum;
(function (TypeFlowEnum) {
    TypeFlowEnum["PHYSICAL_PERSON"] = "0";
    TypeFlowEnum["LEGAL_PERSON"] = "1";
    TypeFlowEnum["MEI"] = "2";
    TypeFlowEnum["LIBERAL_PROFESSIONAL"] = "3";
})(TypeFlowEnum || (TypeFlowEnum = {}));

var OwnershipEnum;
(function (OwnershipEnum) {
    OwnershipEnum["OWNERAOFTHECCOUNT"] = "OWNERAOFTHECCOUNT";
    OwnershipEnum["SPOUSE"] = "SPOUSE";
    OwnershipEnum["FATHERORMOTHER"] = "FATHERORMOTHER";
    OwnershipEnum["BROTHERORSISTER"] = "BROTHERORSISTER";
})(OwnershipEnum || (OwnershipEnum = {}));

/*
 * Public API Surface of ui-bs-signup-proxy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, Deleted, LevelRiskEnum, MaritalEnum, OwnershipEnum, PositionPhotoEnum, SpeJOpenAccountUploadProxy, SpeNOpenAccountProxy, SpeNOpenAccountUploadProxy, SpeViewOpenAccountProxy, SpeViewPreAccountProxy, Status, StatusDefaultEnum, TypeAccountEnum, TypeEnum, TypeFlowEnum, UiPxSignupModule, UploadTypeEnum, YesOrNot };
//# sourceMappingURL=wlp-ui-px-signup.js.map
